import i18n from '@/i18n';

export const formatInteger = (value: number): string => {
  return new Intl.NumberFormat(i18n.language).format(value);
};
